/**
 * @file Inline/page loading indicator with shared .spin animation.
 */

import React from 'react';
import { Loader } from 'lucide-react';

/**
 * Inline / page loading indicator using the shared .spin animation.
 */
function LoadingSpinner({
  size = 40,
  label = 'Loading...',
  className = '',
  style,
  labelStyle,
}) {
  return (
    <div className={`loading ${className}`.trim()} style={style}>
      <Loader className="spin" size={size} aria-hidden />
      {label ? <p style={labelStyle}>{label}</p> : null}
    </div>
  );
}

export default LoadingSpinner;
